package ru.education.building.schedule.widgets.pager

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.scrollBy
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.PagerDefaults
import androidx.compose.foundation.pager.PagerState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Bookmark
import androidx.compose.material.icons.filled.Weekend
import androidx.compose.material.icons.outlined.BookmarkBorder
import androidx.compose.material.icons.outlined.Place
import androidx.compose.material3.AssistChip
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.Icon
import androidx.compose.material3.IconToggleButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.plus
import ru.education.building.schedule.data.models.Misis
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalTime::class)
@Composable
fun CustomPager(items: List<Misis>, pagerState: PagerState, lazyListState: LazyListState, startDate: LocalDate) {

    HorizontalPager(
        //key = { page -> page },
        state = pagerState,
        //pageSize = PageSize.Fill,
        //beyondViewportPageCount = 1,
        //contentPadding = PaddingValues(all = 20.dp),
        pageSpacing = 16.dp,
        verticalAlignment = Alignment.Top, // <- Чтобы элементы не сьезжали вниз
        flingBehavior = PagerDefaults.flingBehavior(
            state = pagerState,
        ),
        modifier = Modifier
            .fillMaxWidth()
            .height(599.dp) // 663 -> высота страницы - 64 высота topAppBar = 599
    ) { page ->

        val listState = rememberLazyListState()
        val coroutineScope = rememberCoroutineScope()

        LaunchedEffect(page) {
            if (pagerState.settledPage != page) {
                listState.scrollToItem(0)
            }
        }

        val nestedScrollConnection = remember {
            object : NestedScrollConnection {
                override fun onPreScroll(
                    available: Offset,
                    source: NestedScrollSource
                ): Offset {
                    val delta = available.y

                    // Если родитель может скроллиться, скроллим его вручную
                    if (delta < 0 && lazyListState.canScrollForward) {
                        coroutineScope.launch {
                            // Скроллим родителя на величину доступного delta
                            lazyListState.scrollBy(-delta)
                        }
                        // Потребляем весь скролл
                        return available.copy(x = 0f)
                    }

                    // Иначе не потребляем - дочерний будет скроллиться
                    return Offset.Zero
                }
            }
        }

        val currentDate = startDate.plus(page, DateTimeUnit.DAY)
        val currentIsoDayNumber = currentDate.dayOfWeek.isoDayNumber
        val targetDate = currentDate.toString()
        val filteredItems = remember(items) {
            items.filter { it.date == targetDate }
        }

        LazyColumn(
            state = listState,
            modifier = Modifier.nestedScroll(nestedScrollConnection),
            verticalArrangement = Arrangement.spacedBy(16.dp),
            contentPadding = PaddingValues(
                all = 16.dp
            )
        ) {
            if (filteredItems.isEmpty() && currentIsoDayNumber == 7) {
                item {
                    EmptyScheduleCard()
                }
            }
            items(filteredItems) { item ->
                ScheduleCardV2(item)
            }
        }
    }
}

@Composable
private fun ScheduleCardV2(item: Misis) {
    Surface(shadowElevation = 4.dp, modifier = Modifier.clip(RoundedCornerShape(16.dp))) {
        Box(Modifier.background(MaterialTheme.colorScheme.surfaceVariant)) {
            Row(
                Modifier.fillMaxWidth().padding(12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    Text(if (item.time_start != "") item.time_start else "00:00", style = MaterialTheme.typography.titleSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                    Spacer(Modifier.height(3.dp))
                    Box(
                        Modifier.width(2.dp).height(10.dp)
                            .background(MaterialTheme.colorScheme.primary.copy(alpha = 0.5f), RoundedCornerShape(1.dp))
                    )
                    Spacer(Modifier.height(3.dp))
                    Text(if (item.time_end != "") item.time_end else "00:00", style = MaterialTheme.typography.titleSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }

                Spacer(Modifier.width(14.dp))

                Column(Modifier.weight(1f)) {
                    Text(
                        item.subject ?: "",
                        style = MaterialTheme.typography.titleMedium,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis
                    )
                    Spacer(Modifier.height(6.dp))
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Outlined.Place, contentDescription = null, modifier = Modifier.size(16.dp))
                        Spacer(Modifier.width(4.dp))
                        Text(
                            item.room,
                            style = MaterialTheme.typography.bodyMedium,
                            //color = MaterialTheme.colorScheme.onSurfaceVariant,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                    Spacer(Modifier.height(8.dp))

                    Column {
                        if (item.type != null) {
                            Text(
                                text = item.type,
                                style = MaterialTheme.typography.titleSmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier
                                    //.background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), RoundedCornerShape(16.dp))
                                    .border(1.4.dp, MaterialTheme.colorScheme.primary,
                                        shape = RoundedCornerShape(15.dp))
                                    .padding(top = 7.dp, bottom = 7.dp, start = 9.dp, end = 9.dp)
                            )
                        }
                        Spacer(Modifier.height(7.dp))
                        if (item.teacher != null) {
                            Text(
                                text = item.teacher,
                                style = MaterialTheme.typography.titleSmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant,
                                modifier = Modifier
                                    //.background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), RoundedCornerShape(16.dp))
                                    .border(1.4.dp, MaterialTheme.colorScheme.primary,
                                        shape = RoundedCornerShape(15.dp))
                                    .padding(top = 7.dp, bottom = 7.dp, start = 9.dp, end = 9.dp)
                            )
                        }
                    }
                }
            }
        }
    }
}


@Composable
fun EmptyScheduleCard() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(32.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(
                imageVector = Icons.Default.Weekend,
                contentDescription = null,
                modifier = Modifier.size(64.dp),
                tint = MaterialTheme.colorScheme.primary.copy(alpha = 0.95f)
            )
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                text = "В этот день пар нет",
                style = MaterialTheme.typography.titleMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Text(
                text = "Отдыхай!",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.8f)
            )
        }
    }
}


@Composable
private fun DisplayScheduleCard(item: Misis) {
    ScheduleCard(
        title = item.subject ?: "",
        startTime = item.time_start,
        endTime = item.time_end,
        location = item.room,
        tags = listOf(
            item.type ?: "",
            item.teacher ?: ""
        ),
        isFavorite = true,
        onFavoriteToggle = {}
    )
}


@Composable
private fun ScheduleCard(
    title: String,
    startTime: String,
    endTime: String,
    location: String?,
    tags: List<String>,
    isFavorite: Boolean,
    onFavoriteToggle: () -> Unit,
    modifier: Modifier = Modifier,
) {
    ElevatedCard(modifier, shape = RoundedCornerShape(16.dp)) {
        Row(
            Modifier.fillMaxWidth().padding(12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(startTime, style = MaterialTheme.typography.titleSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                Spacer(Modifier.height(3.dp))
                Box(
                    Modifier.width(2.dp).height(10.dp)
                        .background(MaterialTheme.colorScheme.primary.copy(alpha = 0.3f), RoundedCornerShape(1.dp))
                )
                Spacer(Modifier.height(3.dp))
                Text(endTime, style = MaterialTheme.typography.titleSmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Spacer(Modifier.width(12.dp))
            Column(Modifier.weight(1f)) {
                Text(
                    title,
                    style = MaterialTheme.typography.titleMedium,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
                if (location != null) {
                    Spacer(Modifier.height(6.dp))
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Outlined.Place, contentDescription = null, modifier = Modifier.size(16.dp))
                        Spacer(Modifier.width(4.dp))
                        Text(
                            location,
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
                if (tags.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    FlowRow {
                        tags.take(3).forEach { tag ->
                            AssistChip(onClick = {}, label = { Text(tag) })
                        }
                        if (tags.size > 3) {
                            AssistChip(onClick = {}, label = { Text("+${tags.size - 3}") })
                        }
                    }
                }
            }
            IconToggleButton(checked = isFavorite, onCheckedChange = { onFavoriteToggle() }) {
                Icon(
                    imageVector = if (isFavorite) Icons.Filled.Bookmark else Icons.Outlined.BookmarkBorder,
                    contentDescription = "favorite"
                )
            }
        }
    }
}

